import { render, staticRenderFns } from "./SignalingServer.vue?vue&type=template&id=461ff05c&scoped=true&"
import script from "./SignalingServer.vue?vue&type=script&lang=js&"
export * from "./SignalingServer.vue?vue&type=script&lang=js&"
import style0 from "./SignalingServer.vue?vue&type=style&index=0&id=461ff05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ff05c",
  null
  
)

export default component.exports